// React
import { cloneElement, isValidElement } from "react";

// Components
import { Paper, Stack, Typography } from "@mui/material";

const MBSPaperCard = ({ icon, title, subtitle, headerRight, children }) => {
  const styledIcon = isValidElement(icon)
    ? cloneElement(icon, { fontSize: "large", color: "primary" })
    : null;

  return (
    <Paper sx={{ width: "100%", p: { xs: 2, sm: 3 }, boxSizing: "border-box" }}>
      <Stack spacing={2}>
        <Stack
          direction={headerRight ? { xs: "column", sm: "row" } : "column"}
          spacing={1}
          justifyContent={{ xs: "flex-start", sm: "space-between" }}
          alignItems={
            headerRight ? "center" : { xs: "center", sm: "flex-start" }
          }
        >
          <Stack direction="row" spacing={1} width="auto" alignItems="center">
            {styledIcon}
            <Typography
              variant="h3"
              sx={{ whiteSpace: { xs: "normal", sm: "nowrap" } }}
            >
              {title}
            </Typography>
          </Stack>
          {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
          {headerRight && <Stack width="auto">{headerRight}</Stack>}
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
};

export default MBSPaperCard;
